import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect, PromiseState } from 'react-refetch';

import PromiseStateContainer from '../../apiAccess/PromiseStateContainer';
import BASE_URL from '../../apiAccess/urls';
import { createSubheaderRow, createMultiFoodFullRows } from '../../util/util';
import MultiFoodResultTable from './MultiFoodResultTable';

const createCsvHeader = foods => {
  const csvHeader = [
    {label: 'Category', key: 'category'},
    {label: 'Nutrient', key: 'nutrient'},
    {label: 'Unit', key: 'unit'},
  ];
  foods.forEach((food, i) => {
    csvHeader.push({
      label: food.shortname, key: `food${i + 1}`
    });
  });
  return csvHeader;
};

class MultiFoodFullGrouped extends Component {
  constructor(props) {
    super(props);
    this.renderOnFulfillment = this.renderOnFulfillment.bind(this);
  }

  componentDidMount() {
    const csvHeader = createCsvHeader(this.props.selectedFoods);
    this.props.setCsvHeader(csvHeader);
  }

  componentWillReceiveProps(nextProps) {
    if(this.props.selectedFoods !== nextProps.selectedFoods) {
      const csvHeader = createCsvHeader(nextProps.selectedFoods);
      this.props.setCsvHeader(csvHeader);
    }
  }

  render() {
    const {
      unitFetch,
      carbsTotalsComponentSetFetch,
      carbsAvailableComponentSetFetch,
      carbsSugarsComponentSetFetch,
      carbsIndividualSugarsComponentSetFetch,
      carbsStarchComponentSetFetch,
      carbsUnavailableComponentSetFetch,
      carotenoidsComponentSetFetch,
      energyComponentSetFetch,
      fatsComponentSetFetch,
      mineralsComponentSetFetch,
      organicAcidsComponentSetFetch,
      proteinComponentSetFetch,
      vitaminsWaterComponentSetFetch,
      vitaminsFatComponentSetFetch,
      otherComponentSetFetch,
      food1FullFetch, food2FullFetch, food3FullFetch,
    } = this.props;
    return (
      <PromiseStateContainer
        ps={PromiseState.all([
          unitFetch,
          carbsTotalsComponentSetFetch,
          carbsAvailableComponentSetFetch,
          carbsSugarsComponentSetFetch,
          carbsIndividualSugarsComponentSetFetch,
          carbsStarchComponentSetFetch,
          carbsUnavailableComponentSetFetch,
          carotenoidsComponentSetFetch,
          energyComponentSetFetch,
          fatsComponentSetFetch,
          mineralsComponentSetFetch,
          organicAcidsComponentSetFetch,
          proteinComponentSetFetch,
          vitaminsWaterComponentSetFetch,
          vitaminsFatComponentSetFetch,
          otherComponentSetFetch,
          food1FullFetch, food2FullFetch, food3FullFetch,
        ].filter(n => n))}
        onFulfillment={this.renderOnFulfillment}
      />
    );
  }

  renderOnFulfillment([
    units,
    carbsTotalsComponentSet,
    carbsAvailableComponentSet,
    carbsSugarsComponentSet,
    carbsIndividualSugarsComponentSet,
    carbsStarchComponentSet,
    carbsUnavailableComponentSet,
    carotenoidsComponentSet,
    energyComponentSet,
    fatsComponentSet,
    mineralsComponentSet,
    organicAcidsComponentSet,
    proteinComponentSet,
    vitaminsWaterComponentSet,
    vitaminsFatComponentSet,
    otherComponentSet,
    ...foodFulls
  ]) {
    // combine full of each food to food objects
    const { selectedFoods, selectedReport, per100g } = this.props;
    selectedFoods.forEach((food, i) => {
      food.components = foodFulls[i];
    });

    const tableData = createSubheaderRow('Carbohydrates')
      .concat(createMultiFoodFullRows(carbsTotalsComponentSet.components, selectedFoods, units, per100g))
      .concat(createSubheaderRow('Available', 2))
      .concat(createMultiFoodFullRows(carbsAvailableComponentSet.components, selectedFoods, units, per100g))
      .concat(createSubheaderRow('Sugars', 2))
      .concat(createMultiFoodFullRows(carbsSugarsComponentSet.components, selectedFoods, units, per100g))
      .concat(createSubheaderRow('Individual Sugars', 2))
      .concat(createMultiFoodFullRows(carbsIndividualSugarsComponentSet.components, selectedFoods, units, per100g))
      .concat(createSubheaderRow('Starch', 2))
      .concat(createMultiFoodFullRows(carbsStarchComponentSet.components, selectedFoods, units, per100g))
      .concat(createSubheaderRow('Unavailable', 2))
      .concat(createMultiFoodFullRows(carbsUnavailableComponentSet.components, selectedFoods, units, per100g))
      .concat(createSubheaderRow('Carotenoids'))
      .concat(createMultiFoodFullRows(carotenoidsComponentSet.components, selectedFoods, units, per100g))
      .concat(createSubheaderRow('Energy'))
      .concat(createMultiFoodFullRows(energyComponentSet.components, selectedFoods, units, per100g))
      .concat(createSubheaderRow('Fats and Fatty Acids'))
      .concat(createMultiFoodFullRows(fatsComponentSet.components, selectedFoods, units, per100g))
      .concat(createSubheaderRow('Minerals'))
      .concat(createMultiFoodFullRows(mineralsComponentSet.components, selectedFoods, units, per100g))
      .concat(createSubheaderRow('Organic Acids'))
      .concat(createMultiFoodFullRows(organicAcidsComponentSet.components, selectedFoods, units, per100g))
      .concat(createSubheaderRow('Protein and Amino Acids'))
      .concat(createMultiFoodFullRows(proteinComponentSet.components, selectedFoods, units, per100g))
      .concat(createSubheaderRow('Vitamins Water Soluble'))
      .concat(createMultiFoodFullRows(vitaminsWaterComponentSet.components, selectedFoods, units, per100g))
      .concat(createSubheaderRow('Vitamins Fat Soluble'))
      .concat(createMultiFoodFullRows(vitaminsFatComponentSet.components, selectedFoods, units, per100g))
      .concat(createSubheaderRow('Other'))
      .concat(createMultiFoodFullRows(otherComponentSet.components, selectedFoods, units, per100g));

    return (
      <div className="MultiFoodResult">

        <MultiFoodResultTable
          tableType='fullGrouped'
          tableData={tableData}
          selectedFoods={selectedFoods}
          selectedReport={selectedReport}
          setCsvData={this.props.setCsvData}
          per100g = {per100g}
        />

      </div>
    );
  }
}

MultiFoodFullGrouped.propTypes = {
  unitFetch: PropTypes.instanceOf(PromiseState),
  carbsTotalsComponentSetFetch: PropTypes.instanceOf(PromiseState),
  carbsAvailableComponentSetFetch: PropTypes.instanceOf(PromiseState),
  carbsSugarsComponentSetFetch: PropTypes.instanceOf(PromiseState),
  carbsIndividualSugarsComponentSetFetch: PropTypes.instanceOf(PromiseState),
  carbsStarchComponentSetFetch: PropTypes.instanceOf(PromiseState),
  carbsUnavailableComponentSetFetch: PropTypes.instanceOf(PromiseState),
  carotenoidsComponentSetFetch: PropTypes.instanceOf(PromiseState),
  energyComponentSetFetch: PropTypes.instanceOf(PromiseState),
  fatsComponentSetFetch: PropTypes.instanceOf(PromiseState),
  mineralsComponentSetFetch: PropTypes.instanceOf(PromiseState),
  organicAcidsComponentSetFetch: PropTypes.instanceOf(PromiseState),
  proteinComponentSetFetch: PropTypes.instanceOf(PromiseState),
  vitaminsWaterComponentSetFetch: PropTypes.instanceOf(PromiseState),
  vitaminsFatComponentSetFetch: PropTypes.instanceOf(PromiseState),
  otherComponentSetFetch: PropTypes.instanceOf(PromiseState),
  food1FullFetch: PropTypes.instanceOf(PromiseState),
  food2FullFetch: PropTypes.instanceOf(PromiseState),
  food3FullFetch: PropTypes.instanceOf(PromiseState),
  selectedFoods: PropTypes.array,
  selectedReport: PropTypes.string,
  per100g: PropTypes.bool.isRequired,
  setCsvHeader: PropTypes.func.isRequired,
  setCsvData: PropTypes.func.isRequired,
};

const fetch = props => {
  if (!props.selectedFoods) { return null; } // don't fetch
  let fetchObject = {
    unitFetch: `${BASE_URL}/unit`,
    carbsTotalsComponentSetFetch: `${BASE_URL}/component/set/13`,
    carbsAvailableComponentSetFetch: `${BASE_URL}/component/set/14`,
    carbsSugarsComponentSetFetch: `${BASE_URL}/component/set/15`,
    carbsIndividualSugarsComponentSetFetch: `${BASE_URL}/component/set/16`,
    carbsStarchComponentSetFetch: `${BASE_URL}/component/set/17`,
    carbsUnavailableComponentSetFetch: `${BASE_URL}/component/set/18`,
    carotenoidsComponentSetFetch: `${BASE_URL}/component/set/19`,
    energyComponentSetFetch: `${BASE_URL}/component/set/20`,
    fatsComponentSetFetch: `${BASE_URL}/component/set/21`,
    mineralsComponentSetFetch: `${BASE_URL}/component/set/22`,
    organicAcidsComponentSetFetch: `${BASE_URL}/component/set/23`,
    proteinComponentSetFetch: `${BASE_URL}/component/set/24`,
    vitaminsWaterComponentSetFetch: `${BASE_URL}/component/set/25`,
    vitaminsFatComponentSetFetch: `${BASE_URL}/component/set/26`,
    otherComponentSetFetch: `${BASE_URL}/component/set/27`,
  };
  props.selectedFoods.forEach((food, i) => {
    const query = food.serving_size_value ? `?amount=${food.serving_size_value}&` : '?';
    fetchObject[`food${i + 1}FullFetch`] = `${BASE_URL}/fiav/food/${food.recordid}${query}comp_group_id=12`;
  });
  return fetchObject;
};

export default connect(fetch)(MultiFoodFullGrouped);



// WEBPACK FOOTER //
// ./src/components/search/multiFood/MultiFoodFullGrouped.js